import { ExperimentVariants } from "@/utils/experiments";

export default function useExperiments(experimentCode: string) {
  return ExperimentVariants[experimentCode];
}
